import { render, staticRenderFns } from "./aiCgAnalysis.vue?vue&type=template&id=02666a9c&scoped=true"
import script from "./aiCgAnalysis.vue?vue&type=script&lang=js"
export * from "./aiCgAnalysis.vue?vue&type=script&lang=js"
import style0 from "./aiCgAnalysis.vue?vue&type=style&index=0&id=02666a9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02666a9c",
  null
  
)

export default component.exports